module.exports = __webpack_public_path__ + "li.319a774214f8fe6fcd8b.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/li.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/li.svg
// module chunks = styles